"use client";
import { jsxs as e, jsx as l } from "react/jsx-runtime";
const h = ({
  title: i,
  titleId: r,
  desc: a,
  descId: t,
  ...d
}) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-rw",
    viewBox: "0 0 640 480",
    "aria-labelledby": r,
    "aria-describedby": t,
    ...d,
    children: [
      a ? /* @__PURE__ */ l("desc", { id: t, children: a }) : null,
      i ? /* @__PURE__ */ l("title", { id: r, children: i }) : null,
      /* @__PURE__ */ l("path", { fill: "#20603d", d: "M0 0h640v480H0z" }),
      /* @__PURE__ */ l("path", { fill: "#fad201", d: "M0 0h640v360H0z" }),
      /* @__PURE__ */ l("path", { fill: "#00a1de", d: "M0 0h640v240H0z" }),
      /* @__PURE__ */ e("g", { transform: "translate(511 125.4)scale(.66667)", children: [
        /* @__PURE__ */ e("g", { id: "rw-b", children: [
          /* @__PURE__ */ l(
            "path",
            {
              id: "rw-a",
              fill: "#e5be01",
              d: "M116.1 0 35.7 4.7l76.4 25.4-78.8-16.3L100.6 58l-72-36.2L82 82.1 21.9 28.6l36.2 72-44.3-67.3L30 112 4.7 35.7 0 116.1-1-1z"
            }
          ),
          /* @__PURE__ */ l(
            "use",
            {
              xlinkHref: "#rw-a",
              width: "100%",
              height: "100%",
              transform: "scale(1 -1)"
            }
          )
        ] }),
        /* @__PURE__ */ l(
          "use",
          {
            xlinkHref: "#rw-b",
            width: "100%",
            height: "100%",
            transform: "scale(-1 1)"
          }
        ),
        /* @__PURE__ */ l("circle", { r: 34.3, fill: "#e5be01", stroke: "#00a1de", strokeWidth: 3.4 })
      ] })
    ]
  }
);
export {
  h as default
};
